export default "__VITE_ASSET__8OeXafiX__"